// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"473":"cd97aa47","512":"a8ca8c9c"}[chunkId] + ".chunk.js";
};